import { Component, OnInit, Input } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import { routerNgProbeToken } from '@angular/router/src/router_module';

@Component({
  selector: 'app-how-it-works',
  templateUrl: './how-it-works.component.html',
  styleUrls: ['./how-it-works.component.scss']
})
export class HowItWorksComponent implements OnInit {

  showNextTime: boolean = true;

  intro:boolean = false;

  constructor(private router: Router, private cookieService: CookieService, private route:ActivatedRoute ) { }

  ngOnInit() {
    this.intro = this.route.snapshot.paramMap.get("type") == "intro"

    this.showNextTime = this.cookieService.get('hide-how-it-works') === "true";
  }

  onHide(){
    this.cookieService.set('hide-how-it-works', this.showNextTime ? 'true' : 'false');      

    this.router.navigateByUrl('/');
  }

}
